import { t as toggleBooleanAttribute } from './toggleBooleanAttribute-BIjS1aGN.js';

class CollapsibleElement extends HTMLElement {
  /** @type {HTMLElement} */ #controller = this.querySelector('[aria-controls]');
  /** @type {HTMLElement} */ #target = this.#controller.ariaControlsElements[0];

  connectedCallback() {
    this.#controller.addEventListener('click', () => this.#handleClick());
  }

  #handleClick() {
    toggleBooleanAttribute(this.#controller, 'aria-expanded');
    toggleBooleanAttribute(this.#target, 'aria-hidden');
  }
}

customElements.define('collapsible-element', CollapsibleElement);
